import { type AppLocale } from 'app-shared/types';
import { assertUnreachable } from 'app-shared/utils';

import { type ClerkLocalization } from '@/auth/clerk/types/ClerkLocalization';

// Only the active language is downloaded; English is built into Clerk.
export const loadClerkBaseLocalization = async (
  locale: AppLocale,
): Promise<ClerkLocalization | undefined> => {
  switch (locale) {
    case 'en':
      return undefined;
    case 'fr': {
      const { frFR } = await import('@clerk/localizations/fr-FR');

      return frFR;
    }
    default:
      return assertUnreachable(locale);
  }
};
